var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuDarkSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.5C9.5 2.67157 8.82843 2 8 2C7.17157 2 6.5 2.67157 6.5 3.5V3.508C6.5 4.33643 7.17157 5.008 8 5.008C8.82843 5.008 9.5 4.33643 9.5 3.508V3.5Z",
    fill: "#677B99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.25136C8.82843 6.25136 9.5 6.92294 9.5 7.75136V7.75936C9.5 8.58779 8.82843 9.25936 8 9.25936C7.17157 9.25936 6.5 8.58779 6.5 7.75936V7.75136C6.5 6.92294 7.17157 6.25136 8 6.25136Z",
    fill: "#677B99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.4964C8.82843 10.4964 9.5 11.168 9.5 11.9964V12.0044C9.5 12.8328 8.82843 13.5044 8 13.5044C7.17157 13.5044 6.5 12.8328 6.5 12.0044V11.9964C6.5 11.168 7.17157 10.4964 8 10.4964Z",
    fill: "#677B99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDarkSmall);
export default __webpack_public_path__ + "static/media/menu-dark-small.099ec92c783332325e3af248343fb7a0.svg";
export { ForwardRef as ReactComponent };